import {createAction} from "@reduxjs/toolkit";

import {
  FETCH,
  DONE,
  FAIL,
  EDIT,
  DELETE,
  HANDLE,
  SET,
  ADD,
  ADMISSION_EDUCATION,
  ADMISSION_FOUR_SPECIALITIES_ARRAY,
  ADMISSION_STEPS_DATA,
  ADMISSION_LANGUAGES,
  ADMISSION_FOUR_SPECIALITIES_DATA,
  ADMISSION_PROVINCES,
  ADMISSION_DOCUMENT,
  ADMISSION_IIN,
  ADMISSION_INFO,
  ADMISSION_MARKS,
  ADMISSION_NEW_MARK,
  ADMISSION_PROFILE,
  ADMISSION_LESSON,
  RESULT,
  ADMISSION_EXAM,
  GET,
  ADMISSION_ORDER,
  STUDY,
  ADMISSION_GROUPS,
  ADMISSION_STATUS,
  ADMISSION_STUDENT_LIST,
  ADMISSION_EXECUTOR_EGOV_APPLICATION,
  ADMISSION_TOTAL,
  ADMISSION_REASON,
  SPECIALITIES,
  ADMISSION_COLLEGE_AND_EXECUTOR,
  RESET,
  ADMISSION_ENTRANT_APPLICATIONS,
  ADMISSION_LOG,
  ADMISSION_GENERAL_CONTEST,
  ADMISSION_GENERAL_CONTEST_WITH_QUOTES,
  ADMISSION_GENERAL_CONTEST_COLLEGE_LIST_TO_TRANSFER,
  ADMISSION_GENERAL_CONTEST_CHANGE_STATUS,
  ADMISSION_GENERAL_CONTEST_SPECIALITIES_LIST,
  ADMISSION_GENERAL_CONTEST_TRANSFER_TO_COLLEGE,
  ADMISSION_COLLEGES,
  ADMISSION_EMAIL, ADMISSION_ENTRANT_INFO, ADMISSION_EDUCATION_ORDER_XML, POST, LEAVE,
} from "../../constants"


export const createEducationOrderAction = createAction(ADMISSION_EDUCATION + FETCH)
export const createEducationOrderActionDone = createAction(ADMISSION_EDUCATION + FETCH + DONE)
export const createEducationOrderActionFail = createAction(ADMISSION_EDUCATION + FETCH + FAIL)

export const createSelectedSpecialityAction = createAction(ADMISSION_FOUR_SPECIALITIES_ARRAY + FETCH);
export const createSelectedSpecialityActionDone = createAction(ADMISSION_FOUR_SPECIALITIES_ARRAY + FETCH + DONE);
export const createSelectedSpecialityActionFail = createAction(ADMISSION_FOUR_SPECIALITIES_ARRAY + FETCH + FAIL);
export const createSelectedSpecialityActionReset = createAction(ADMISSION_FOUR_SPECIALITIES_ARRAY + RESET);

export const changeSelectedSpecialityPriorityAction = createAction(ADMISSION_FOUR_SPECIALITIES_ARRAY + EDIT);
export const changeSelectedSpecialityPriorityActionDone = createAction(ADMISSION_FOUR_SPECIALITIES_ARRAY + EDIT + DONE);
export const changeSelectedSpecialityPriorityActionFail = createAction(ADMISSION_FOUR_SPECIALITIES_ARRAY + EDIT + FAIL);

export const deleteSelectedSpecialityAction = createAction<any>(ADMISSION_FOUR_SPECIALITIES_ARRAY + DELETE);
export const deleteSelectedSpecialityActionDone = createAction(ADMISSION_FOUR_SPECIALITIES_ARRAY + DELETE + DONE);
export const deleteSelectedSpecialityActionFail = createAction(ADMISSION_FOUR_SPECIALITIES_ARRAY + DELETE + FAIL);
export const handleSetSelectedSpecialityActions = createAction(ADMISSION_FOUR_SPECIALITIES_ARRAY + HANDLE)

export const setStepsData = createAction(ADMISSION_STEPS_DATA + SET);
export const resetStepsData = createAction(ADMISSION_STEPS_DATA + RESET);

export const fetchLanguagesForSpecialitiesFormAction = createAction(ADMISSION_LANGUAGES + FETCH);
export const fetchLanguagesForSpecialitiesFormActionDone = createAction(ADMISSION_LANGUAGES + FETCH + DONE);
export const fetchLanguagesForSpecialitiesFormActionFail = createAction(ADMISSION_LANGUAGES + FETCH + FAIL);

export const fetchDataForSpecialitiesFormAction = createAction<any>(ADMISSION_FOUR_SPECIALITIES_DATA + FETCH);
export const fetchDataForSpecialitiesFormActionDone = createAction(ADMISSION_FOUR_SPECIALITIES_DATA + FETCH + DONE);
export const fetchDataForSpecialitiesFormActionFail = createAction(ADMISSION_FOUR_SPECIALITIES_DATA + FETCH + FAIL);
export const fetchDataForSpecialitiesFormActionReset = createAction(ADMISSION_FOUR_SPECIALITIES_DATA + FETCH + RESET);

export const fetchCollegesWithQualificationsAction = createAction<any>(ADMISSION_FOUR_SPECIALITIES_DATA + ADMISSION_COLLEGES + FETCH);
export const fetchCollegesWithQualificationsActionDone = createAction(ADMISSION_FOUR_SPECIALITIES_DATA + ADMISSION_COLLEGES + FETCH + DONE);
export const fetchCollegesWithQualificationsActionFail = createAction(ADMISSION_FOUR_SPECIALITIES_DATA + ADMISSION_COLLEGES + FETCH + FAIL);
export const fetchCollegesWithQualificationsActionReset = createAction(ADMISSION_FOUR_SPECIALITIES_DATA + ADMISSION_COLLEGES + RESET);

export const fetchProvincesAction = createAction(ADMISSION_PROVINCES + FETCH);
export const fetchProvincesActionDone = createAction(ADMISSION_PROVINCES + FETCH + DONE);
export const fetchProvincesActionFail = createAction(ADMISSION_PROVINCES + FETCH + FAIL);

export const fetchEducationEditOrderAction = createAction<any>(ADMISSION_EDUCATION + EDIT + FETCH)
export const fetchEducationEditOrderActionDone = createAction(ADMISSION_EDUCATION + EDIT + DONE)
export const fetchEducationEditOrderActionFail = createAction(ADMISSION_EDUCATION + EDIT + FAIL)

//documents
export const fetchCreateAdmissionDocumentAction = createAction(ADMISSION_DOCUMENT + FETCH);
export const fetchCreateAdmissionDocumentActionDone = createAction(ADMISSION_DOCUMENT + FETCH + DONE);
export const fetchCreateAdmissionDocumentActionFail = createAction(ADMISSION_DOCUMENT + FETCH + FAIL);

//check iin
export const fetchCheckIinAction = createAction(ADMISSION_IIN + FETCH);
export const fetchCheckIinActionDone = createAction(ADMISSION_IIN + FETCH + DONE);
export const fetchCheckIinActionFail = createAction(ADMISSION_IIN + FETCH + FAIL);

//check email
export const fetchCheckEmailAction = createAction(ADMISSION_EMAIL + FETCH);
export const fetchCheckEmailActionDone = createAction(ADMISSION_EMAIL + FETCH + DONE);
export const fetchCheckEmailActionFail = createAction(ADMISSION_EMAIL + FETCH + FAIL);

//edit steps
export const fetchGetInfoAction = createAction(ADMISSION_INFO + FETCH);
export const fetchGetInfoActionDone = createAction(ADMISSION_INFO + FETCH + DONE);
export const fetchGetInfoActionFail = createAction(ADMISSION_INFO + FETCH + FAIL);
export const resetGetInfoAction = createAction(ADMISSION_INFO + RESET);

//third step marks
export const fetchGetMarksAction = createAction(ADMISSION_MARKS + FETCH);
export const fetchGetMarksActionDone = createAction(ADMISSION_MARKS + FETCH + DONE);
export const fetchGetMarksActionFail = createAction(ADMISSION_MARKS + FETCH + FAIL);

export const fetchAddLessonAction = createAction(ADMISSION_LESSON + ADD);
export const fetchAddLessonActionDone = createAction(ADMISSION_LESSON + ADD + DONE);
export const fetchAddLessonActionFail = createAction(ADMISSION_LESSON + ADD + FAIL);

export const fetchAddLessonProfileAction = createAction(ADMISSION_LESSON + ADMISSION_PROFILE + ADD);
export const fetchAddLessonProfileActionDone = createAction(ADMISSION_LESSON + ADMISSION_PROFILE + ADD + DONE);
export const fetchAddLessonProfileActionFail = createAction(ADMISSION_LESSON + ADMISSION_PROFILE + ADD + FAIL);

export const fetchAddLessonProfileNewAction = createAction(ADMISSION_LESSON + ADMISSION_PROFILE + ADMISSION_NEW_MARK + ADD);
export const fetchAddLessonProfileNewActionDone = createAction(ADMISSION_LESSON + ADMISSION_PROFILE + ADMISSION_NEW_MARK + ADD + DONE);
export const fetchAddLessonProfileNewActionFail = createAction(ADMISSION_LESSON + ADMISSION_PROFILE + ADMISSION_NEW_MARK + ADD + FAIL);

export const fetchEditNewProfileLessonAction = createAction(ADMISSION_LESSON + ADMISSION_PROFILE + ADMISSION_NEW_MARK + EDIT);
export const fetchEditNewProfileLessonActionDone = createAction(ADMISSION_LESSON + ADMISSION_PROFILE + ADMISSION_NEW_MARK + EDIT + DONE);
export const fetchEditNewProfileLessonActionFail = createAction(ADMISSION_LESSON + ADMISSION_PROFILE + ADMISSION_NEW_MARK + EDIT + FAIL);

export const fetchDeleteProfileNewLessonAction = createAction(ADMISSION_LESSON + ADMISSION_PROFILE + ADMISSION_NEW_MARK + DELETE);
export const fetchDeleteProfileNewLessonActionDone = createAction(ADMISSION_LESSON + ADMISSION_PROFILE + ADMISSION_NEW_MARK + DELETE + DONE);
export const fetchDeleteProfileNewLessonActionFail = createAction(ADMISSION_LESSON + ADMISSION_PROFILE + ADMISSION_NEW_MARK + DELETE + FAIL);

export const fetchEditLessonAction = createAction(ADMISSION_LESSON + EDIT);
export const fetchEditLessonActionDone = createAction(ADMISSION_LESSON + EDIT + DONE);
export const fetchEditLessonActionFail = createAction(ADMISSION_LESSON + EDIT + FAIL);

export const fetchDeleteLessonAction = createAction(ADMISSION_LESSON + DELETE);
export const fetchDeleteLessonActionDone = createAction(ADMISSION_LESSON + DELETE + DONE);
export const fetchDeleteLessonActionFail = createAction(ADMISSION_LESSON + DELETE + FAIL);

export const educationDocumentRatingAction = createAction(ADMISSION_EDUCATION + ADMISSION_DOCUMENT + ADMISSION_MARKS + FETCH)
export const educationDocumentRatingActionDone = createAction(ADMISSION_EDUCATION + ADMISSION_DOCUMENT + ADMISSION_MARKS + FETCH + DONE)
export const educationDocumentRatingActionFail = createAction(ADMISSION_EDUCATION + ADMISSION_DOCUMENT + ADMISSION_MARKS + FETCH + FAIL)

export const fetchSetExamMarkAction = createAction(SET + ADMISSION_EXAM + ADMISSION_MARKS)
export const fetchSetExamMarkActionDone = createAction(SET + ADMISSION_EXAM + ADMISSION_MARKS + DONE)
export const fetchSetExamMarkActionFail = createAction(SET + ADMISSION_EXAM + ADMISSION_MARKS + FAIL)

export const fetchSetExamResultAction = createAction(SET + ADMISSION_EXAM + RESULT)
export const fetchSetExamResultActionDone = createAction(SET + ADMISSION_EXAM + RESULT + DONE)
export const fetchSetExamResultActionFail = createAction(SET + ADMISSION_EXAM + RESULT + FAIL)

export const fetchGroupListAction = createAction(ADMISSION_GROUPS + ADMISSION_INFO)
export const fetchGroupListActionDone = createAction(ADMISSION_GROUPS + ADMISSION_INFO + DONE)
export const fetchGroupListActionFail = createAction(ADMISSION_GROUPS + ADMISSION_INFO + FAIL)

export const fetchSetStatusAction = createAction(SET + ADMISSION_STATUS)
export const fetchSetStatusActionDone = createAction(SET + ADMISSION_STATUS + DONE)
export const fetchSetStatusActionFail = createAction(SET + ADMISSION_STATUS + FAIL)

export const fetchOrderCreate = createAction(ADD + ADMISSION_ORDER)
export const fetchOrderCreateDone = createAction(ADD + ADMISSION_ORDER + DONE)
export const fetchOrderCreateFail = createAction(ADD + ADMISSION_ORDER + FAIL)

export const fetchOrderEdit = createAction<any>(EDIT + ADMISSION_ORDER)
export const fetchOrderEditDone = createAction(EDIT + ADMISSION_ORDER + DONE)
export const fetchOrderEditFail = createAction(EDIT + ADMISSION_ORDER + FAIL)


export const fetchOrderLeaveStudent = createAction<any>(ADMISSION_ORDER + LEAVE)
export const fetchOrderLeaveStudentDone = createAction(ADMISSION_ORDER + LEAVE + DONE)
export const fetchOrderLeaveStudentFail = createAction(ADMISSION_ORDER + LEAVE + FAIL)


export const fetchOrderView = createAction<any>(ADMISSION_ORDER + FETCH)
export const fetchOrderViewDone = createAction(ADMISSION_ORDER + FETCH + DONE)
export const fetchOrderViewFail = createAction(ADMISSION_ORDER + FETCH + FAIL)

export const fetchGetTotalResultAction = createAction(GET + ADMISSION_TOTAL + RESULT)
export const fetchGetTotalResultActionDone = createAction(GET + ADMISSION_TOTAL + RESULT + DONE)
export const fetchGetTotalResultActionFail = createAction(GET + ADMISSION_TOTAL + RESULT + FAIL)

export const fetchExamResultAction = createAction(ADMISSION_EXAM + RESULT)
export const fetchExamResultActionDone = createAction(ADMISSION_EXAM + RESULT + DONE)
export const fetchExamResultActionFail = createAction(ADMISSION_EXAM + RESULT + FAIL)

export const fetchSetSpecialityStatusAction = createAction(SET + ADMISSION_STATUS + SPECIALITIES)
export const fetchSetSpecialityStatusActionDone = createAction(SET + ADMISSION_STATUS + SPECIALITIES + DONE)
export const fetchSetSpecialityStatusActionFail = createAction(SET + ADMISSION_STATUS + SPECIALITIES + FAIL)

export const fetchCollegeAndExecutorAction = createAction(ADMISSION_COLLEGE_AND_EXECUTOR + FETCH);
export const fetchCollegeAndExecutorActionDone = createAction(ADMISSION_COLLEGE_AND_EXECUTOR + FETCH + DONE);
export const fetchCollegeAndExecutorActionFail = createAction(ADMISSION_COLLEGE_AND_EXECUTOR + FETCH + FAIL);

//Получение айди студента по номеру заявки
export const fetchGetStudentByEducationOrder = createAction(ADMISSION_EDUCATION + ADMISSION_ORDER + GET + STUDY + FETCH)
export const fetchGetStudentByEducationOrderDone = createAction(ADMISSION_EDUCATION + ADMISSION_ORDER + GET + STUDY + DONE)
export const fetchGetStudentByEducationOrderFail = createAction(ADMISSION_EDUCATION + ADMISSION_ORDER + GET + STUDY + FAIL)

//Зачисление в картотеку
export const fetchAddToStudentList = createAction(ADD + ADMISSION_STUDENT_LIST + FETCH)
export const fetchAddToStudentListDone = createAction(ADD + ADMISSION_STUDENT_LIST + DONE)
export const fetchAddToStudentListFail = createAction(ADD + ADMISSION_STUDENT_LIST + FAIL)

//Проставить исполнителя для заявки с Егова
export const fetchExecutorEgovApplication = createAction(ADMISSION_EXECUTOR_EGOV_APPLICATION + FETCH)
export const fetchExecutorEgovApplicationDone = createAction(ADMISSION_EXECUTOR_EGOV_APPLICATION + FETCH + DONE)
export const fetchExecutorEgovApplicationFail = createAction(ADMISSION_EXECUTOR_EGOV_APPLICATION + FETCH + FAIL)

//Причина отказа
export const fetchDeclineReason = createAction(ADMISSION_REASON + FETCH)
export const fetchDeclineReasonDone = createAction(ADMISSION_REASON + DONE)
export const fetchDeclineReasonFail = createAction(ADMISSION_REASON + FAIL)

//Заявления абитуриента
export const fetchEntrantApplicationsAction = createAction(ADMISSION_ENTRANT_APPLICATIONS + FETCH);
export const fetchEntrantApplicationsActionDone = createAction(ADMISSION_ENTRANT_APPLICATIONS + FETCH + DONE);
export const fetchEntrantApplicationsActionFail = createAction(ADMISSION_ENTRANT_APPLICATIONS + FETCH + FAIL);

//admission log
export const fetchAdmissionLog = createAction(ADMISSION_LOG + FETCH)
export const fetchAdmissionLogDone = createAction(ADMISSION_LOG + FETCH + DONE)
export const fetchAdmissionLogFail = createAction(ADMISSION_LOG + FETCH + FAIL)

//Общий конкурс приёмка

//Запрос заявок
export const fetchGeneralContestAction = createAction(ADMISSION_GENERAL_CONTEST + FETCH)
export const fetchGeneralContestActionDone = createAction(ADMISSION_GENERAL_CONTEST + FETCH + DONE)
export const fetchGeneralContestActionFail = createAction(ADMISSION_GENERAL_CONTEST + FETCH + FAIL)

//Запрос заявок с квотами
export const fetchGeneralContestWithQuotesAction = createAction(ADMISSION_GENERAL_CONTEST_WITH_QUOTES + FETCH)
export const fetchGeneralContestWithQuotesActionDone = createAction(ADMISSION_GENERAL_CONTEST_WITH_QUOTES + FETCH + DONE)
export const fetchGeneralContestWithQuotesActionFail = createAction(ADMISSION_GENERAL_CONTEST_WITH_QUOTES + FETCH + FAIL)

//Запрос списка специальностей
export const fetchGeneralContestSpecialitiesListAction = createAction(ADMISSION_GENERAL_CONTEST_SPECIALITIES_LIST + FETCH)
export const fetchGeneralContestSpecialitiesListActionDone = createAction(ADMISSION_GENERAL_CONTEST_SPECIALITIES_LIST + FETCH + DONE)
export const fetchGeneralContestSpecialitiesListActionFail = createAction(ADMISSION_GENERAL_CONTEST_SPECIALITIES_LIST + FETCH + FAIL)
export const fetchGeneralContestSpecialitiesListActionResets = createAction(ADMISSION_GENERAL_CONTEST_SPECIALITIES_LIST + RESET)

//Смена статуса абитуриента
export const editEntrantStatusAction = createAction(ADMISSION_GENERAL_CONTEST_CHANGE_STATUS + FETCH)
export const editEntrantStatusActionDone = createAction(ADMISSION_GENERAL_CONTEST_CHANGE_STATUS + FETCH + DONE)
export const editEntrantStatusActionFail = createAction(ADMISSION_GENERAL_CONTEST_CHANGE_STATUS + FETCH + FAIL)

//Получение списка колледжей для трансфера
export const fetchCollegeListToTransferAction = createAction(ADMISSION_GENERAL_CONTEST_COLLEGE_LIST_TO_TRANSFER + FETCH)
export const fetchCollegeListToTransferActionDone = createAction(ADMISSION_GENERAL_CONTEST_COLLEGE_LIST_TO_TRANSFER + FETCH + DONE)
export const fetchCollegeListToTransferActionFail = createAction(ADMISSION_GENERAL_CONTEST_COLLEGE_LIST_TO_TRANSFER + FETCH + FAIL)

//Трансфер абитуриента в другой колледж
export const fetchEntrantTransferToOtherCollegeAction = <any>createAction(ADMISSION_GENERAL_CONTEST_TRANSFER_TO_COLLEGE + FETCH)
export const fetchEntrantTransferToOtherCollegeActionDone = createAction(ADMISSION_GENERAL_CONTEST_TRANSFER_TO_COLLEGE + FETCH + DONE)
export const fetchEntrantTransferToOtherCollegeActionFail = createAction(ADMISSION_GENERAL_CONTEST_TRANSFER_TO_COLLEGE + FETCH + FAIL)


//entrant-info
export const fetchEntrantInfoAction = createAction(ADMISSION_ENTRANT_INFO + FETCH)
export const fetchEntrantInfoActionDone = createAction(ADMISSION_ENTRANT_INFO + FETCH + DONE)
export const fetchEntrantInfoActionFail = createAction(ADMISSION_ENTRANT_INFO + FETCH + FAIL)

//entrant-info
export const fetchEducationOrderXMLAction = createAction<any>(ADMISSION_EDUCATION_ORDER_XML + FETCH)
export const fetchEducationOrderXMLActionDone = createAction(ADMISSION_EDUCATION_ORDER_XML + FETCH + DONE)
export const fetchEducationOrderXMLActionFail = createAction(ADMISSION_EDUCATION_ORDER_XML + FETCH + FAIL)

export const postEducationOrderXMLAction = createAction<any>(ADMISSION_EDUCATION_ORDER_XML + POST)
export const postEducationOrderXMLActionDone = createAction(ADMISSION_EDUCATION_ORDER_XML + POST + DONE)
export const postEducationOrderXMLActionFail = createAction(ADMISSION_EDUCATION_ORDER_XML + POST + FAIL)
export const postEducationOrderXMLActionReset = createAction(ADMISSION_EDUCATION_ORDER_XML + POST + RESET)
